import AutoComplete, { OptionType } from '@/components/AutoComplete';
import { flexStyle, textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  padding: 8px 0;
  margin: 0 auto;
`;
export const Title = styled.div`
  ${textStyle({
    color: 'textPrimary',
    lineHeight: 1,
    size: '16px',
    textAlign: 'left',
    weight: 500,
  })};
  margin-bottom: 16px;
`;
export const ToggleGroup = styled.div``;
export const FormControlWrapper = styled.div``;
export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;
export const AutoCompleteWrapper = styled.div`
  ${flexStyle({ align: 'flex-start', direction: 'row' })};
  gap: 20px;
  margin-top: 10px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
`;
export const AutoCompleteContainer = styled(AutoComplete<OptionType, false>)`
  width: 45%;
  margin-bottom: 10px;
`;
export const MemoGroup = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
  padding: 0 8px 4px 16px;
`;
export const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
